import store from '@/store'

/**
 * 角色标识
 * 单一来源：后端 GET /user/config 返回的 ntc_role
 */
export const ROLES = {
  ADMIN: 'admin',
  DEV: 'dev',
  USER: 'user'
}

/** 全部角色 */
export const ALL_ROLES = [ROLES.ADMIN, ROLES.DEV, ROLES.USER]

/** 获取当前登录用户角色，未登录或未就绪时返回空字符串 */
export function getRole() {
  return store.getters.ntcRole || ''
}

/** 是否管理员 */
export function isAdmin() {
  return getRole() === ROLES.ADMIN
}

/** 是否管理员或开发者 */
export function isAdminOrDev() {
  return [ROLES.ADMIN, ROLES.DEV].includes(getRole())
}

/**
 * 校验当前用户是否具备访问 / 操作权限
 * - 管理员（admin）默认拥有全部权限
 * - required 为空表示仅需登录即可
 * @param {string|string[]|undefined|null} required 允许的角色，支持单个角色或角色数组
 * @returns {boolean}
 */
export function hasPermission(required) {
  const role = getRole()
  if (!role) return false
  if (role === ROLES.ADMIN) return true
  if (!required) return true
  const roles = Array.isArray(required) ? required : [required]
  if (!roles.length) return true
  return roles.includes(role)
}

/**
 * 按钮级权限点
 * key：权限点编码；value：允许的角色列表
 * 说明：管理员（admin）默认拥有全部权限，此处仍显式声明各权限点的允许角色，便于集中审阅
 * 用法：<a-button v-permission="PERMISSIONS.CHANNEL_DELETE">删除</a-button>
 */
export const PERMISSIONS = {
  // 通讯录
  CONTACT_ROLE_UPDATE: [ROLES.ADMIN],
  CONTACT_SYNC: [ROLES.ADMIN],
  CONTACT_EXPORT: [ROLES.ADMIN, ROLES.DEV],

  // 通知管理
  NOTICE_CREATE: [ROLES.ADMIN, ROLES.DEV],
  NOTICE_UPDATE: [ROLES.ADMIN, ROLES.DEV],
  NOTICE_DELETE: [ROLES.ADMIN, ROLES.DEV],

  // 通道与模板
  CHANNEL_CREATE: [ROLES.ADMIN, ROLES.DEV],
  CHANNEL_UPDATE: [ROLES.ADMIN, ROLES.DEV],
  CHANNEL_DELETE: [ROLES.ADMIN, ROLES.DEV],
  CHANNEL_TEST: [ROLES.ADMIN, ROLES.DEV],
  TEMPLATE_CREATE: [ROLES.ADMIN, ROLES.DEV],
  TEMPLATE_UPDATE: [ROLES.ADMIN, ROLES.DEV],
  TEMPLATE_DELETE: [ROLES.ADMIN, ROLES.DEV],
  CHANNEL_GROUP_MANAGE: [ROLES.ADMIN, ROLES.DEV],
  MESSAGE_GROUP_MANAGE: [ROLES.ADMIN, ROLES.DEV],
  TODO_CATEGORY_MANAGE: [ROLES.ADMIN, ROLES.DEV],

  // 监控中心
  NOTICE_RETRY: [ROLES.ADMIN, ROLES.DEV],
  EVENT_LOG_EXPORT: [ROLES.ADMIN, ROLES.DEV],
  EVENT_TYPE_MANAGE: [ROLES.ADMIN, ROLES.DEV],

  // 开发者中心
  TOKEN_MANAGE: [ROLES.ADMIN, ROLES.DEV]
}
